import React from "react";
import {
  Button,
  Typography,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Divider,
  Box
} from "@mui/material";
import { jsPDF } from "jspdf";
import QRCode from "react-qr-code";
import html2canvas from "html2canvas";
import { einvoice, einvoice2, einvoiceData } from "./util";
import Barcode from "react-barcode";
import invoice from "../config/invoice.json";
import ewaybill from "../config/ewaybiil.json";

const EInvoice = ({ invoice }) => {
  const invoiceParse = invoice && JSON.parse(invoice);

  const dass = invoiceParse && JSON.parse(invoiceParse?.data);

  const invoiceParseData = JSON.parse(dass?.Data);
  console.log(invoiceParseData, "vahsb1");

  // const ewaybillParse = ewaybill && JSON.parse(ewaybill.data);
  // const ewaybillParseData = invoice && JSON.parse(invoiceParse.Data);

  const {
    SignedInvoice,
    EwbDt,
    EwbNo,
    EwbValidTill,
    ExtractedSignedInvoiceData,
    SignedQRCode,
    Irn,
    AckNo,
    AckDt
  } = invoiceParseData;

  // const {
  //   ewayBillDate = EwbValidTill,
  //   ewayBillNo = EwbNo,
  //   validUpto = EwbValidTill
  // } = invoiceParseData;

  const generatePDF = async () => {
    const element = document.getElementById("invoice");
    if (!element) {
      return;
    }

    // Render the HTML content to a canvas
    const canvas = await html2canvas(element, { scale: 3 });
    const contentWidth = canvas.width;
    const contentHeight = canvas.height;

    // A4 size in points: 210mm x 297mm
    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4"
    });

    const pdfWidth = pdf.internal.pageSize.getWidth(); // 210mm
    const pdfHeight = pdf.internal.pageSize.getHeight(); // 297mm

    // Define margins (in mm)
    const marginTop = 5; // Top margin
    const marginLeft = 5; // Left margin
    const marginBottom = 5; // Bottom margin
    const marginRight = 5; // Right margin

    // Calculate the content width and height considering margins
    const contentWidthAdjusted = pdfWidth - marginLeft - marginRight;
    const contentHeightAdjusted = pdfHeight - marginTop - marginBottom;

    // Calculate the scaling factor to fit content on the page considering margins
    const scaleFactor = contentWidthAdjusted / contentWidth;
    const imgHeight = contentHeight * scaleFactor;

    // Calculate how much content fits on one page (in canvas pixels)
    const pageHeightInCanvasPixels =
      (contentHeightAdjusted * contentWidth) / contentWidthAdjusted;

    let currentHeight = 0;

    while (currentHeight < contentHeight) {
      // Create a cropped canvas for the current page
      const cropCanvas = document.createElement("canvas");
      cropCanvas.width = contentWidth;
      cropCanvas.height = Math.min(
        pageHeightInCanvasPixels,
        contentHeight - currentHeight
      );

      const ctx = cropCanvas.getContext("2d");
      ctx.drawImage(
        canvas,
        0,
        currentHeight, // Start from the current height
        contentWidth,
        cropCanvas.height, // Crop this height
        0,
        0,
        cropCanvas.width,
        cropCanvas.height
      );

      const croppedData = cropCanvas.toDataURL("image/png");

      // Add the cropped image to the PDF with margins
      pdf.addImage(
        croppedData,
        "PNG",
        marginLeft,
        marginTop,
        contentWidthAdjusted,
        cropCanvas.height * scaleFactor // Adjust the image height with the scale factor
      );

      currentHeight += pageHeightInCanvasPixels; // Move to the next section

      // Add a new page if there's more content
      if (currentHeight < contentHeight) {
        pdf.addPage();
      }
    }

    // Save the PDF
    pdf.save("document.pdf");
  };

  const labelFontSize = 17;
  const labelFontWeight = 700;
  const subLabelFontWeight = 700;
  const borderColor = "rgba(0, 0, 0, 0.24)";
  const textSize = 17;

  // const decodeJWT = (token) => {
  //   // Split the JWT into three parts
  //   const parts = token.split('.');

  //   if (parts.length !== 3) {
  //     throw new Error("Invalid JWT format.");
  //   }

  //   // Decode the header and payload from Base64
  //   const header = JSON.parse(atob(parts[0])); // Base64 decode header
  //   const payload = JSON.parse(atob(parts[1])); // Base64 decode payload

  //   // Extract and decode the signature if it exists in the payload
  //   let signatureImage = null;
  //   if (payload && payload.SignedInvoice) {
  //     const signatureBase64 = payload.SignedInvoice; // Replace with the actual field name if different
  //     try {
  //       // Decode the Base64-encoded signature
  //       const decodedData = atob(signatureBase64);
  //       const byteArray = new Uint8Array(decodedData.length);
  //       for (let i = 0; i < decodedData.length; i++) {
  //         byteArray[i] = decodedData.charCodeAt(i);
  //       }

  //       // Create a Blob from the byte array and convert to URL
  //       const blob = new Blob([byteArray], { type: 'image/png' }); // Or 'image/jpeg'
  //       signatureImage = URL.createObjectURL(blob); // This is a URL you can use for the image
  //     } catch (error) {
  //       console.error('Error decoding or extracting signature:', error);
  //     }
  //   }

  //   return { header, payload, signatureImage };
  // };

  // const jwtToken = "eyJhbGciOiJSUzI1NiIsImtpZCI6IjE1MTNCODIxRUU0NkM3NDlBNjNCODZFMzE4QkY3MTEwOTkyODdEMUYiLCJ4NXQiOiJGUk80SWU1R3gwbW1PNGJqR0w5eEVKa29mUjgiLCJ0eXAiOiJKV1QifQ.eyJpc3MiOiJOSUMgU2FuZGJveCIsImRhdGEiOiJ7XCJBY2tOb1wiOjE1MjUxMDAyNDM1ODgwNCxcIkFja0R0XCI6XCIyMDI1LTAxLTE2IDE4OjA2OjA0XCIsXCJJcm5cIjpcIjMxNjVlYzRjYzEzNzQ5NzgxNTExMzY2NWMwN2M5M2M4NmJhNmM3ZGZiZWMzMGVlN2JkMGI4MWZiMjNjZGEzZmFcIixcIlZlcnNpb25cIjpcIjEuMVwiLFwiVHJhbkR0bHNcIjp7XCJUYXhTY2hcIjpcIkdTVFwiLFwiU3VwVHlwXCI6XCJCMkJcIn0sXCJEb2NEdGxzXCI6e1wiVHlwXCI6XCJEQk5cIixcIk5vXCI6XCJPUkQwNTQ1ODZcIixcIkR0XCI6XCIxNi8wMS8yMDI1XCJ9LFwiU2VsbGVyRHRsc1wiOntcIkdzdGluXCI6XCIzNEFBQ0NDMTU5NlEwMDJcIixcIkxnbE5tXCI6XCJCYW5rXCIsXCJBZGRyMVwiOlwiNXRoIGJsb2NrLCBrdXZlbXB1IGxheW91dFwiLFwiTG9jXCI6XCJHYW5kaGluYWdhclwiLFwiUGluXCI6NjA1MDAxLFwiU3RjZFwiOlwiMzRcIn0sXCJCdXllckR0bHNcIjp7XCJHc3RpblwiOlwiMDZBQUNDTjQwNzBFMVpUXCIsXCJMZ2xObVwiOlwiSEVBRCBPRkZJQ0VcIixcIlBvc1wiOlwiMTJcIixcIkFkZHIxXCI6XCJHdXJnYW9uXCIsXCJMb2NcIjpcIkhvbWVcIixcIlBpblwiOjEyMjAxNyxcIlN0Y2RcIjpcIjA2XCJ9LFwiSXRlbUxpc3RcIjpbe1wiSXRlbU5vXCI6MCxcIlNsTm9cIjpcIjFcIixcIklzU2VydmNcIjpcIk5cIixcIlByZERlc2NcIjpcIkdQU1wiLFwiSHNuQ2RcIjpcIjg1MjY5MVwiLFwiUXR5XCI6MTAsXCJVbml0XCI6XCJCQUxcIixcIlVuaXRQcmljZVwiOjEwMCxcIlRvdEFtdFwiOjEwMDAsXCJBc3NBbXRcIjoxMDAwLjAwLFwiR3N0UnRcIjoxOCxcIklnc3RBbXRcIjoxODAsXCJUb3RJdGVtVmFsXCI6MTE4MH0se1wiSXRlbU5vXCI6MCxcIlNsTm9cIjpcIjJcIixcIklzU2VydmNcIjpcIk5cIixcIlByZERlc2NcIjpcIkRlbGwgaGVhZHBob25lXCIsXCJIc25DZFwiOlwiODUyNjkxXCIsXCJRdHlcIjoxMCxcIlVuaXRcIjpcIkJETFwiLFwiVW5pdFByaWNlXCI6NTAsXCJUb3RBbXRcIjo1MDAsXCJBc3NBbXRcIjo1MDAuMDAsXCJHc3RSdFwiOjE4LFwiSWdzdEFtdFwiOjkwLFwiVG90SXRlbVZhbFwiOjU5MH0se1wiSXRlbU5vXCI6MCxcIlNsTm9cIjpcIjNcIixcIklzU2VydmNcIjpcIk5cIixcIlByZERlc2NcIjpcIkhQIExhcHRvcFwiLFwiSHNuQ2RcIjpcIjg1MjY5MVwiLFwiUXR5XCI6MzAwLFwiVW5pdFwiOlwiQk9VXCIsXCJVbml0UHJpY2VcIjo3MCxcIlRvdEFtdFwiOjIxMDAwLFwiQXNzQW10XCI6MjEwMDAuMDAsXCJHc3RSdFwiOjE4LFwiSWdzdEFtdFwiOjM3ODAsXCJUb3RJdGVtVmFsXCI6MjQ3ODB9XSxcIlZhbER0bHNcIjp7XCJBc3NWYWxcIjoyMjUwMCxcIklnc3RWYWxcIjo0MDUwLFwiVG90SW52VmFsXCI6MjY1NTB9fSJ9.y0h2Q3YyBj0X-YTvQwHkTu-QEUBckqnR6WZVaDQwfdb7numcU2_NSl7LZY84DgHysea8Lm4jsLBuRQEy1VjzszZ1cRoReZsViZUjV8rqEXVlZQIH2yPpQsyWCATVsrh4cKZVwifPRcALEKjaZXwgLjZid4E8Nblx-udI3n6sXOXeU8RF_uOnz_5tvU3Mqe5_efdHxmQeyLJLymhtrzzP2RsaNd_WruhFsWTFMGa5GLV5m5FmYSisOQWKZUGxy9C_ekzUIslNvPw54ZyjSnKxjWErwdcoyB2o13a5POpB-m3IYP_Cmbd1W0SwXFK8m7KdCn0WtdllJGoMlq33-b1c_A";
  // const { header, payload, signatureImage } = decodeJWT(jwtToken);
  // console.log("Header:", header);
  // console.log("Payload:", payload);
  // console.log(signatureImage);

  // const decodedData = decodeBase64(SignedInvoice);
  // console.log(decodedData);

  return (
    <div>
      <Paper
        id="invoice"
        elevation={3}
        sx={{
          padding: 4,
          background: "#fff",
          border: "1px solid #ccc",
          fontFamily: "'Arial', sans-serif",
          span: {
            fontSize: "17px"
          },
          p: {
            fontSize: "17px !important"
          }
        }}
      >
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <Typography
              variant="h6"
              sx={{ fontSize: "30px", fontWeight: "700" }}
            >
              {ExtractedSignedInvoiceData?.SellerDtls?.Gstin || "NA"}
            </Typography>
            <Typography
              variant="h6"
              sx={{ fontSize: "30px", fontWeight: "700" }}
            >
              {ExtractedSignedInvoiceData?.SellerDtls?.LglNm || "NA"}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <div
              style={{
                height: "auto",
                maxWidth: 300,
                width: "100%",
                marginLeft: "auto"
              }}
            >
              {SignedQRCode && (
                <QRCode
                  size={400}
                  style={{
                    height: "auto",
                    maxWidth: "100%",
                    width: "100%"
                  }}
                  value={SignedQRCode}
                  viewBox={`0 0 256 256`}
                />
              )}
            </div>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={1}
          sx={{ border: `1px solid ${borderColor}` }}
          mt={2}
        >
          <Grid item xs={12}>
            <Typography
              sx={{ fontWeight: labelFontWeight, fontSize: labelFontSize }}
            >
              1. E-Invoice Details
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item container xs={12} spacing={2}>
            <Grid item xs={4} sx={{ display: "flex" }}>
              <span
                style={{
                  fontWeight: labelFontWeight,
                  fontSize: labelFontSize,
                  width: "20%"
                }}
              >
                IRN :{" "}
              </span>
              <span style={{ overflowWrap: "anywhere" }}>{Irn || "NA"}</span>
            </Grid>
            <Grid item xs={4}>
              <span
                style={{ fontWeight: labelFontWeight, fontSize: labelFontSize }}
              >
                Ack. No :{" "}
              </span>
              <span>{AckNo || "NA"}</span>
            </Grid>
            <Grid item xs={4}>
              <span
                style={{ fontWeight: labelFontWeight, fontSize: labelFontSize }}
              >
                Ack. Date :{" "}
              </span>
              <span>{AckDt || "NA"}</span>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          container
          mt={1}
          spacing={1}
          sx={{ border: `1px solid ${borderColor}` }}
        >
          <Grid item xs={12}>
            <Typography
              sx={{ fontWeight: labelFontWeight, fontSize: labelFontSize }}
            >
              2. Transaction Details
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{ padding: 0 }}>
            <Divider />
          </Grid>
          <Grid item container xs={12} spacing={2}>
            <Grid item xs={4}>
              <span
                style={{ fontWeight: labelFontWeight, fontSize: labelFontSize }}
              >
                Supply Type Code :{" "}
              </span>
              <span>
                {ExtractedSignedInvoiceData?.TranDtls?.SupTyp || "NA"}
              </span>
            </Grid>
            <Grid item xs={4}>
              <span
                style={{ fontWeight: labelFontWeight, fontSize: labelFontSize }}
              >
                Document No :{" "}
              </span>
              <span>{ExtractedSignedInvoiceData?.DocDtls?.No || "NA"}</span>
            </Grid>
            <Grid item xs={4}>
              <span
                style={{ fontWeight: labelFontWeight, fontSize: labelFontSize }}
              >
                IGST applicable despite Supplier and Recipient located in same
                State :{" "}
              </span>
              <span>
                {ExtractedSignedInvoiceData?.TranDtls?.IgstOnIntra === "N"
                  ? "No"
                  : "Yes" || "NA"}
              </span>
            </Grid>
          </Grid>
          <Grid item xs={12} sx={{ padding: 0 }}>
            <Divider />
          </Grid>
          <Grid item xs={12}>
            <span
              style={{ fontWeight: labelFontWeight, fontSize: labelFontSize }}
            >
              Place of Supply :{" "}
            </span>
            <span>{ExtractedSignedInvoiceData?.DispDtls?.Loc || "NA"}</span>
          </Grid>
          <Grid item xs={12} sx={{ padding: 0 }}>
            <Divider />
          </Grid>
          <Grid item container xs={12} spacing={2}>
            <Grid item xs={4}>
              <span
                style={{ fontWeight: labelFontWeight, fontSize: labelFontSize }}
              >
                Document Type :{" "}
              </span>
              <span>
                {ExtractedSignedInvoiceData?.DocDtls?.Typ === "INV"
                  ? "Tax Invoice"
                  : ExtractedSignedInvoiceData?.DocDtls?.Typ === "CRN"
                  ? "Credit Note"
                  : ExtractedSignedInvoiceData?.DocDtls?.Typ === "DBN"
                  ? "Debit Note"
                  : "-"}
              </span>
            </Grid>
            <Grid item xs={8}>
              <span
                style={{ fontWeight: labelFontWeight, fontSize: labelFontSize }}
              >
                Document Date :
              </span>
              <span>{ExtractedSignedInvoiceData?.DocDtls?.Dt || "NA"}</span>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          container
          mt={1}
          spacing={1}
          sx={{ border: `1px solid ${borderColor}` }}
        >
          <Grid item xs={12}>
            <Typography
              sx={{ fontWeight: labelFontWeight, fontSize: labelFontSize }}
            >
              3. Party Details
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid
            item
            xs={6}
            sx={{ borderRight: "1px solid", borderColor: "divider" }}
          >
            <Typography sx={{ fontWeight: subLabelFontWeight }}>
              Supplier
            </Typography>
            <Typography>
              GSTIN : {ExtractedSignedInvoiceData?.SellerDtls?.Gstin || "NA"}
            </Typography>
            <Typography>
              {ExtractedSignedInvoiceData?.SellerDtls?.LglNm || "NA"}
            </Typography>
            {ExtractedSignedInvoiceData?.SellerDtls?.Addr1 && (
              <Typography>
                {ExtractedSignedInvoiceData?.SellerDtls?.Addr1 || "NA"}
              </Typography>
            )}
            {ExtractedSignedInvoiceData?.SellerDtls?.Addr2 && (
              <Typography>
                {ExtractedSignedInvoiceData?.SellerDtls?.Addr2 || "NA"}
              </Typography>
            )}
            <Typography>
              {`${ExtractedSignedInvoiceData?.SellerDtls?.Pin} ${ExtractedSignedInvoiceData?.SellerDtls?.Loc}`}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography sx={{ fontWeight: subLabelFontWeight }}>
              Recipient
            </Typography>
            <Typography>
              GSTIN : {ExtractedSignedInvoiceData?.BuyerDtls?.Gstin || "NA"}
            </Typography>
            <Typography>
              {ExtractedSignedInvoiceData?.BuyerDtls?.LglNm || "NA"}
            </Typography>
            {ExtractedSignedInvoiceData?.BuyerDtls?.Addr1 && (
              <Typography>
                {ExtractedSignedInvoiceData?.BuyerDtls?.Addr1 || "NA"}
              </Typography>
            )}
            {ExtractedSignedInvoiceData?.BuyerDtls?.Addr2 && (
              <Typography>
                {ExtractedSignedInvoiceData?.BuyerDtls?.Addr2 || "NA"}
              </Typography>
            )}
            <Typography>
              {`${ExtractedSignedInvoiceData?.BuyerDtls?.Pin} ${ExtractedSignedInvoiceData?.BuyerDtls?.Loc}`}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          mt={1}
          spacing={1}
          sx={{ border: `1px solid ${borderColor}` }}
        >
          <Grid item xs={12}>
            <Typography
              sx={{ fontWeight: labelFontWeight, fontSize: labelFontSize }}
            >
              4. Details of Goods / Services
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12}>
            <TableContainer style={{ marginTop: 0 }}>
              <Table sx={{ border: "1px solid", borderColor: "divider" }}>
                <TableHead>
                  <TableRow>
                    {einvoice?.map((ele) => (
                      <TableCell
                        key={ele?.id}
                        sx={{
                          border: "1px solid",
                          fontWeight: "bold",
                          textAlign: "center",
                          borderColor: "divider"
                        }}
                      >
                        {ele.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {ExtractedSignedInvoiceData?.ItemList?.length > 0 &&
                    ExtractedSignedInvoiceData?.ItemList?.map((ele, i) => (
                      <TableRow>
                        {einvoice?.map((col) =>
                          !col?.alias ? (
                            <TableCell
                              sx={{
                                border: "1px solid",
                                borderColor: "divider",
                                textAlign: "center"
                              }}
                            >
                              {i + 1}
                            </TableCell>
                          ) : col?.alias === "GstRtCesRt" ? (
                            <TableCell
                              sx={{
                                border: "1px solid",
                                borderColor: "divider",
                                textAlign: "center"
                              }}
                            >
                              {+ele?.GstRt +
                                +ele?.CesRt +
                                +ele?.StateCesRt +
                                +ele?.CesNonAdvlAmt +
                                +ele?.StateCesNonAdvlAmt}
                            </TableCell>
                          ) : (
                            <TableCell
                              sx={{
                                border: "1px solid",
                                borderColor: "divider",
                                textAlign: "center"
                              }}
                            >
                              {ele[col?.alias] || "-"}
                            </TableCell>
                          )
                        )}
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid item xs={12}>
            <TableContainer style={{ marginTop: 0 }}>
              <Table sx={{ border: "1px solid", borderColor: "divider" }}>
                <TableHead>
                  <TableRow>
                    {einvoice2?.map((ele) => (
                      <TableCell
                        key={ele?.id}
                        sx={{
                          border: "1px solid",
                          fontWeight: "bold",
                          textAlign: "center",
                          borderColor: "divider"
                        }}
                      >
                        {ele.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {ExtractedSignedInvoiceData?.ValDtls && (
                    <TableRow>
                      <TableCell
                        sx={{
                          border: "1px solid",
                          borderColor: "divider",
                          textAlign: "center"
                        }}
                      >
                        {ExtractedSignedInvoiceData?.ValDtls?.AssVal || 0}
                      </TableCell>
                      <TableCell
                        sx={{
                          border: "1px solid",
                          borderColor: "divider",
                          textAlign: "center"
                        }}
                      >
                        {ExtractedSignedInvoiceData?.ValDtls?.IgstVal || 0}
                      </TableCell>
                      <TableCell
                        sx={{
                          border: "1px solid",
                          borderColor: "divider",
                          textAlign: "center"
                        }}
                      >
                        {ExtractedSignedInvoiceData?.ValDtls?.CgstVal || 0}
                      </TableCell>
                      <TableCell
                        sx={{
                          border: "1px solid",
                          borderColor: "divider",
                          textAlign: "center"
                        }}
                      >
                        {ExtractedSignedInvoiceData?.ValDtls?.SgstVal || 0}
                      </TableCell>
                      <TableCell
                        sx={{
                          border: "1px solid",
                          borderColor: "divider",
                          textAlign: "center"
                        }}
                      >
                        {ExtractedSignedInvoiceData?.ValDtls?.CesVal || 0}
                      </TableCell>
                      <TableCell
                        sx={{
                          border: "1px solid",
                          borderColor: "divider",
                          textAlign: "center"
                        }}
                      >
                        {ExtractedSignedInvoiceData?.ValDtls?.StCesVal || 0}
                      </TableCell>
                      <TableCell
                        sx={{
                          border: "1px solid",
                          borderColor: "divider",
                          textAlign: "center"
                        }}
                      >
                        {ExtractedSignedInvoiceData?.ValDtls?.Discount || 0}
                      </TableCell>
                      <TableCell
                        sx={{
                          border: "1px solid",
                          borderColor: "divider",
                          textAlign: "center"
                        }}
                      >
                        {ExtractedSignedInvoiceData?.ValDtls?.OthChrg || 0}
                      </TableCell>
                      <TableCell
                        sx={{
                          border: "1px solid",
                          borderColor: "divider",
                          textAlign: "center"
                        }}
                      >
                        {ExtractedSignedInvoiceData?.ValDtls?.RndOffAmt || 0}
                      </TableCell>
                      <TableCell
                        sx={{
                          border: "1px solid",
                          borderColor: "divider",
                          textAlign: "center"
                        }}
                      >
                        {ExtractedSignedInvoiceData?.ValDtls?.TotInvVal || 0}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={1}
          sx={{ border: `1px solid ${borderColor}` }}
          mt={1}
        >
          <Grid item xs={12}>
            <Typography
              sx={{ fontWeight: labelFontWeight, fontSize: labelFontSize }}
            >
              5. E-Waybill Details
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item container xs={12}>
            <Grid item xs={4}>
              <span
                style={{ fontWeight: labelFontWeight, fontSize: labelFontSize }}
              >
                Eway Bill No:{" "}
              </span>
              <span>{EwbNo || "-"}</span>
            </Grid>
            <Grid item xs={4}>
              <span
                style={{ fontWeight: labelFontWeight, fontSize: labelFontSize }}
              >
                Eway Bill Date:{" "}
              </span>
              <span>{EwbDt || "-"}</span>
            </Grid>
            <Grid item xs={4}>
              <span
                style={{ fontWeight: labelFontWeight, fontSize: labelFontSize }}
              >
                Valid Till Date:{" "}
              </span>
              <span>{EwbValidTill || "-"}</span>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={1}
          sx={{ border: `1px solid ${borderColor}` }}
          mt={1}
        >
          <Grid item container xs={12}>
            <Grid item xs={8}>
              <Box>
                <span
                  style={{
                    fontWeight: labelFontWeight,
                    fontSize: labelFontSize
                  }}
                >
                  Generated By :{" "}
                </span>
                <span>
                  {ExtractedSignedInvoiceData?.SellerDtls?.Gstin || "-"}
                </span>
              </Box>
              <Box>
                <span
                  style={{
                    fontWeight: labelFontWeight,
                    fontSize: labelFontSize
                  }}
                >
                  Print Date:{" "}
                </span>
                <span>{ExtractedSignedInvoiceData?.DocDtls?.Dt}</span>
              </Box>
            </Grid>
            <Grid item xs={4}>
              <Box>
                <Barcode
                  value={AckNo || "-"}
                  width={2}
                  height={70}
                  fontSize={18}
                />
              </Box>
              {/* <Box sx={{ textAlign: "end" }}>
                <Typography>
                  Digitally Signed by NIC-IRP <br></br>
                  on: 08-12-2024 14:18:00
                </Typography>
              </Box> */}
            </Grid>
          </Grid>
        </Grid>
      </Paper>
      <Button
        variant="contained"
        color="primary"
        onClick={generatePDF}
        style={{ marginTop: 20 }}
      >
        Download
      </Button>
    </div>
  );
};

export default EInvoice;
